module.exports = __webpack_public_path__ + "img/liyou4.208d9a83.png";